import { Container, Row, Col } from "react-bootstrap";
import ProtectedRoutes from "../../../auth/utils/ProtectedRoutes";
import { PageHeader } from "../../../../components/PageHeader";
import { useState } from "react";
import AssigneesBody from "./components/AssigneesBody";

const Assignees = () => {
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <Container fluid>
      <PageHeader
        title="Assignees"
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        // actionButton={{
        //   text: "Add Counsellor Availability +",
        //   link: "/e-counselling/add-availability",
        //   variant: "light",
        //   style: {
        //     fontSize: "12px",
        //     background: "rgba(25, 22, 29, 0.06)",
        //   },
        // }}
      />

      <Row>
        <Col>
          <AssigneesBody searchQuery={searchQuery} />
        </Col>
      </Row>
    </Container>
  );
};

export default ProtectedRoutes(Assignees, {
  allowedRoles: ["Counsellor"],
});
